// import React, { useState, useEffect, useContext } from 'react';
// import { Eye, Trash2, ArrowLeft, History } from 'lucide-react';
// import { Link, useNavigate } from 'react-router-dom';
// import AuthContext from '../../../../../context/AuthContext';
// import historyService from '../../../../../services/historyService';
// import { useToast } from '../../../../../context/ToastContext';
// import Pagination from '../../../../../components/Pagination';

// export default function ActivityLogs() {
//   const { authTokens } = useContext(AuthContext);
//   const { showError } = useToast();
//   const navigate = useNavigate();

//   const [logs, setLogs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
  
//   const [pagination, setPagination] = useState({
//     count: 0,
//     page: 1,
//     page_size: 10,
//     total_pages: 0
//   });

//   useEffect(() => {
//     fetchActivityHistory();
//   }, [pagination.page, pagination.page_size]);

//   const fetchActivityHistory = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const pagination_data = {
//         page: pagination.page,
//         page_size: pagination.page_size,
//       };
      
//       const result = await historyService.getActivityHistory(authTokens.access, {}, pagination_data);
//       if (result.success) {
//         setLogs(result.data.results || result.data);
        
//         // Update pagination info if available
//         if (result.data.count !== undefined) {
//           setPagination(prev => ({
//             ...prev,
//             count: result.data.count,
//             total_pages: result.data.total_pages
//           }));
//         }
//       } else {
//         setError(result.error);
//         showError(result.error || 'Erreur lors du chargement de l\'historique des activités');
//       }
//     } catch (err) {
//       setError('Erreur de connexion');
//       showError('Erreur de connexion');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePageChange = (newPage) => {
//     setPagination(prev => ({ ...prev, page: newPage }));
//   };

//   const handlePageSizeChange = (newPageSize) => {
//     setPagination(prev => ({ 
//       ...prev, 
//       page_size: newPageSize, 
//       page: 1 // Reset to first page
//     }));
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="space-y-6">
//       <div className="flex items-center space-x-3">
//         <Link 
//           to="/dashboard/admin/logs"
//           className="p-2 text-gray-500 hover:text-gray-700 rounded-lg"
//         >
//           <ArrowLeft className="h-5 w-5" />
//         </Link>
//         <h2 className="text-xl font-semibold text-gray-900">Historique des Activités</h2>
//       </div>

//       {error && (
//         <div className="bg-red-50 border border-red-200 rounded-lg p-4">
//           <p className="text-red-800">{error}</p>
//           <button 
//             onClick={fetchActivityHistory}
//             className="mt-2 text-red-600 hover:text-red-800 underline"
//           >
//             Réessayer
//           </button>
//         </div>
//       )}

//       <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
//         <div className="overflow-x-auto">
//           <table className="min-w-full divide-y divide-gray-200">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nom de l'Activité</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fait par</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200">
//               {logs.map((log) => (
//                 <tr key={log.id} className="hover:bg-gray-50">
//                   <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{log.activity_name}</td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                     <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
//                       log.action_type === 'create' ? 'bg-green-100 text-green-800' :
//                       log.action_type === 'update' ? 'bg-blue-100 text-blue-800' :
//                       log.action_type === 'delete' ? 'bg-red-100 text-red-800' :
//                       'bg-gray-100 text-gray-800'
//                     }`}>
//                       {log.action_type === 'create' ? 'Création' :
//                        log.action_type === 'update' ? 'Modification' :
//                        log.action_type === 'delete' ? 'Suppression' :
//                        log.action_type}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{log.done_by_email}</td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{new Date(log.action_date).toLocaleString('fr-FR')}</td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                     <div className="flex items-center space-x-2">
//                       <button 
//                         onClick={() => navigate(`/dashboard/admin/logs/activities/details/${log.id}`)}
//                         className="text-blue-600 hover:text-blue-900 p-1 hover:bg-blue-50 rounded"
//                         title="Voir les détails"
//                       >
//                         <Eye className="h-4 w-4" />
//                       </button>
//                       <button 
//                         className="text-red-600 hover:text-red-900 p-1 hover:bg-red-50 rounded cursor-not-allowed opacity-50"
//                         title="Supprimer (Bientôt disponible)"
//                         disabled
//                       >
//                         <Trash2 className="h-4 w-4" />
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <Pagination
//           currentPage={pagination.page}
//           totalPages={pagination.total_pages}
//           totalItems={pagination.count}
//           pageSize={pagination.page_size}
//           onPageChange={handlePageChange}
//           onPageSizeChange={handlePageSizeChange}
//           loading={loading}
//           itemName="Logs" 
//         />

//         {logs.length === 0 && !loading && (
//           <div className="text-center py-12">
//             <div className="text-gray-500">
//               <History className="h-10 w-10 mx-auto text-gray-400 mb-2" />
//               <p className="text-lg font-medium">Aucun historique trouvé</p>
//               <p className="mt-1">Il n'y a pas encore d'historique pour les activités.</p>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }
















import React, { useState, useEffect, useContext } from 'react';
import { Eye, Trash2, ArrowLeft, History, Shield } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../../../../../context/AuthContext';
import historyService from '../../../../../services/historyService';
import { useToast } from '../../../../../context/ToastContext';
import Pagination from '../../../../../components/Pagination';

export default function ActivityLogs() {
  const { authTokens } = useContext(AuthContext);
  const { showError } = useToast();
  const navigate = useNavigate();

  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [pagination, setPagination] = useState({
    count: 0,
    page: 1,
    page_size: 10,
    total_pages: 0
  });

  useEffect(() => {
    fetchActivityHistory();
  }, [pagination.page, pagination.page_size]);

  const fetchActivityHistory = async () => {
    setLoading(true);
    setError(null);
    try {
      const pagination_data = {
        page: pagination.page,
        page_size: pagination.page_size,
      };
      
      const result = await historyService.getActivityHistory(authTokens.access, {}, pagination_data);
      if (result.success) {
        setLogs(result.data.results || result.data);
        
        // Update pagination info if available
        if (result.data.count !== undefined) {
          setPagination(prev => ({
            ...prev,
            count: result.data.count,
            total_pages: result.data.total_pages
          }));
        }
      } else {
        setError(result.error);
        showError(result.error || 'Erreur lors du chargement de l\'historique des activités');
      }
    } catch (err) {
      setError('Erreur de connexion');
      showError('Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPagination(prev => ({ ...prev, page: newPage }));
  };

  const handlePageSizeChange = (newPageSize) => {
    setPagination(prev => ({ 
      ...prev, 
      page_size: newPageSize, 
      page: 1 // Reset to first page
    }));
  };

  const getHistoryTypeLabel = (historyType) => {
    switch(historyType) {
      case 'activity':
        return 'Activité';
      case 'activity_risk':
        return 'Risque d\'Activité';
      default:
        return historyType;
    }
  };

  const getHistoryTypeColor = (historyType) => {
    switch(historyType) {
      case 'activity':
        return 'bg-purple-100 text-purple-800';
      case 'activity_risk':
        return 'bg-orange-100 text-orange-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-3">
        <Link 
          to="/dashboard/admin/logs"
          className="p-2 text-gray-500 hover:text-gray-700 rounded-lg"
        >
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <h2 className="text-xl font-semibold text-gray-900">Historique des Activités</h2>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-800">{error}</p>
          <button 
            onClick={fetchActivityHistory}
            className="mt-2 text-red-600 hover:text-red-800 underline"
          >
            Réessayer
          </button>
        </div>
      )}

      <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nom de l'Activité</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Détails</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fait par</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {logs.map((log) => (
                <tr key={`${log.history_type}-${log.id}`} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getHistoryTypeColor(log.history_type)}`}>
                      {log.history_type === 'activity_risk' && <Shield className="h-3 w-3 mr-1" />}
                      {getHistoryTypeLabel(log.history_type)}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {log.activity_name}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500">
                    {log.history_type === 'activity_risk' && log.risk_name && (
                      <div className="flex items-center">
                        <span className="text-xs text-gray-600">Risque: {log.risk_name}</span>
                      </div>
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      log.action_type === 'create' ? 'bg-green-100 text-green-800' :
                      log.action_type === 'update' ? 'bg-blue-100 text-blue-800' :
                      log.action_type === 'delete' ? 'bg-red-100 text-red-800' :
                      'bg-gray-100 text-gray-800'
                    }`}>
                      {log.action_type === 'create' ? 'Création' :
                       log.action_type === 'update' ? 'Modification' :
                       log.action_type === 'delete' ? 'Suppression' :
                       log.action_type}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{log.done_by_email}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {new Date(log.action_date).toLocaleString('fr-FR')}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex items-center space-x-2">
                      <button 
                        onClick={() => navigate(`/dashboard/admin/logs/activities/details/${log.history_type}/${log.id}`)}
                        className="text-blue-600 hover:text-blue-900 p-1 hover:bg-blue-50 rounded"
                        title="Voir les détails"
                      >
                        <Eye className="h-4 w-4" />
                      </button>
                      <button 
                        className="text-red-600 hover:text-red-900 p-1 hover:bg-red-50 rounded cursor-not-allowed opacity-50"
                        title="Supprimer (Bientôt disponible)"
                        disabled
                      >
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <Pagination
          currentPage={pagination.page}
          totalPages={pagination.total_pages}
          totalItems={pagination.count}
          pageSize={pagination.page_size}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          loading={loading}
          itemName="Logs" 
        />

        {logs.length === 0 && !loading && (
          <div className="text-center py-12">
            <div className="text-gray-500">
              <History className="h-10 w-10 mx-auto text-gray-400 mb-2" />
              <p className="text-lg font-medium">Aucun historique trouvé</p>
              <p className="mt-1">Il n'y a pas encore d'historique pour les activités.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}